// extracted by mini-css-extract-plugin
export var closeButton = "_pq-2";
export var closeButtonIcon = "_pq-3";
export var lightboxContent = "_pq-1";
export var lightboxOverlay = "_pq-0";